// Module
var code = `<h2 class="section-header">System will execute the following actions:</h2>

<table class="misc-transaction-listing__table table">
  <tbody>
  <tr ng-repeat="step in \$ctrl.stepStatuses">
    <td>{{\$index + 1}}.</td>
    <td>{{step.name | translate:'START_THE_DAY'}}</td>
    <td>{{step.status ? step.status : 'PENDING' | prettyEnum}}</td>
  </tr>
  </tbody>
</table>

<div class="flex-end">
  <button
    class="btn btn-primary"
    type="button"
    ng-click="\$ctrl.goBack()">
    Go back
  </button>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/start-the-day/start-the-day-progress.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;